module.exports = __webpack_public_path__ + "static/media/smartphone.d35b387f.svg";